import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import loadImage from 'common/utils/loadImage';
import PureRenderMixin from 'react-addons-pure-render-mixin';

const IMAGE_BLANK = 0;
const IMAGE_LOADED = 2;

var LazyLoadedImage = createReactClass({
    displayName: 'LazyLoadedImage',
    mixins: [PureRenderMixin],

    propTypes: {
        url: PropTypes.string.isRequired,
        shouldLoad: PropTypes.bool,
    },

    getDefaultProps: function() {
        return {
            shouldLoad: true,
        };
    },

    getInitialState: function() {
        return {
            imageLoadingStatus: IMAGE_BLANK,
        };
    },

    componentDidMount: function() {
        if (this.props.shouldLoad) {
            this.loadImage();
        }
    },

    UNSAFE_componentWillUpdate: function(nextProps) {
        if (nextProps.shouldLoad && !this.props.shouldload) {
            this.loadImage();
        }
    },

    loadImage: function() {
        loadImage(this.props.url)
            .then(() => {
                this.setState({ imageLoadingStatus: IMAGE_LOADED });
            })
            .catch(() => {
                this.setState({ imageLoadingStatus: IMAGE_LOADED });
            });
    },

    renderImage: function() {
        return <img src={this.props.url} />;
    },

    renderPlaceholder: function() {
        return (
            <div style={{ visibility: 'hidden' }}>
                <div style={{ paddingBottom: '100%' }} />
            </div>
        );
    },

    render: function() {
        return this.state.imageLoadingStatus === IMAGE_LOADED
            ? this.renderImage()
            : this.renderPlaceholder();
    },
});

export default LazyLoadedImage;
